<template>
    <dash
        icon="fa fa-dollar"
        titulo="PAGAMENTOS GESCON"
        @click.native="$router.push({ name: 'FornecedorContratos_Pagamentos' })"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
